import { render, staticRenderFns } from "./CompanyLeadsWidget.vue?vue&type=template&id=1d902975&scoped=true&"
import script from "./CompanyLeadsWidget.vue?vue&type=script&lang=js&"
export * from "./CompanyLeadsWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLeadsWidget.vue?vue&type=style&index=0&id=1d902975&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d902975",
  null
  
)

export default component.exports